const compareStrings = (a: string, b: string): number => a.localeCompare(b, undefined, { sensitivity: 'base' });

export default compareStrings;
